import { Text } from '@chakra-ui/react';
import { useMemo } from 'react';

import { urlToExtension } from '~/lib/utils/url';

type Props = {
  downloadUrl: string | null;
  filename: string;
  isDownloadable?: boolean;
};

export const PreviewDigitalContent: React.FC<Props> = (props: Props) => {
  const contentType = useMemo(() => {
    if (props.downloadUrl == null) return null;
    return urlToExtension(props.downloadUrl);
  }, [props.downloadUrl]);

  // 右クリック無効
  const handleContextMenu = (
    e: React.MouseEvent<HTMLVideoElement | HTMLAudioElement>
  ) => {
    e.preventDefault();
  };

  if (props.downloadUrl == null) return null;

  // 画像はモーダルトップでの表示をするため、ここでは表示しない
  if (contentType === 'image') {
    return null;
  }

  if (contentType === 'video') {
    return (
      <video
        controls
        controlsList={!props.isDownloadable ? 'nodownload' : ''}
        onContextMenu={handleContextMenu}
      >
        <track kind="captions" />
        <source src={props.downloadUrl} type="video/mp4" />
      </video>
    );
  }

  if (contentType === 'audio') {
    // iosの一部のバージョンで要素にtypeを指定しないと音声が再生できないための対応
    const MEDIA_TYPE: { [key: string]: string } = {
      mp3: 'audio/mp3',
      wav: 'audio/wav',
    };

    const mediaFileExtension = (() => {
      if (props.downloadUrl == null) return 'mp3';

      const parsedUrl = new URL(props.downloadUrl);
      return parsedUrl.pathname.split('.').pop() ?? 'mp3';
    })();

    return (
      <audio
        controls
        controlsList={!props.isDownloadable ? 'nodownload' : ''}
        onContextMenu={handleContextMenu}
      >
        <source type={MEDIA_TYPE[mediaFileExtension]} src={props.downloadUrl} />
        <track kind="captions" />
      </audio>
    );
  }

  return <Text color="red">プレビューに対応していないコンテンツです</Text>;
};
